import { cn } from '@lib/utils';
import { FunctionComponent, ReactNode } from 'react';

type FormFieldProps = {
  children: ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const FormField: FunctionComponent<FormFieldProps> = ({ children, className, ...props }) => {
  return (
    <div
      className={cn('flex w-full flex-col gap-1.5', className)}
      {...props}
    >
      {children}
    </div>
  );
};
